import { doGetQCXRequest, doPostQCXRequest, doPutQCXRequest } from '../../../utils/api/domain/domain-api-utils';
import { IDiagnostico } from '../../pages/importacao/declaracaoImportacao/components/TransmissaoRenderDados/transmissaoRenderDadosDi';

export interface fetchDataDiagnosticoResponse {
  message: string | null;
  data?: IDiagnostico | null;
}

async function fetchDataDiagnostico(id: number): Promise<fetchDataDiagnosticoResponse> {
  const url: string = process.env.REACT_APP_QCX_API_DECLARACAO_IMPORTACAO_ENDPOINT! + '/resultado-transmissao/di';

  let data: IDiagnostico | null = null;
  let message: string | null = null;

  try {
    const response = await doGetQCXRequest([url, id]);
    data = response.data;
  } catch (error: unknown) {
    if (error instanceof Error && (error.message.includes('404') || error.message.includes('500'))) {
      const errorResponse = (error as any).response?.data;

      message = errorResponse
        ? errorResponse
        : 'com.muralis.qcx.extracaoDiagnostico.erroDeclaracaoNaoAtendeAosRequisitos';
    } else if (error instanceof Error && error.message.includes('401')) {
      message = 'com.muralis.qcx.extracaoDiagnostico.erro401';
    } else {
      message = 'com.muralis.qcx.extracaoDiagnostico.erroInesperado';
    }
  }

  return {
    message: message,
    data: data,
  };
}

async function fetchCriaDiagnostico(id: number, tipo: string, transmitirComImpedimentos = 0): Promise<any> {
  const url: string =
    process.env.REACT_APP_QCX_API_DECLARACAO_IMPORTACAO_ENDPOINT! +
    `/xml-transmissao-diagnostico/di/${id}?TIPO=${tipo}&transmitirComImpedimentos=${transmitirComImpedimentos}`;

  try {
    const response = await doGetQCXRequest([url]);
    return response;
  } catch (error: any) {
    return error.response;
  }
}

async function fetchApagarTransmissaoDuimp(id: number): Promise<any> {
  const url: string =
    process.env.REACT_APP_QCX_API_DECLARACAO_IMPORTACAO_ENDPOINT! + `/v2/transmissao-duimp/${id}/transmissao/deletar`;

  try {
    const response = await doPutQCXRequest([url]);
    return response;
  } catch (error: any) {
    return error.response;
  }
}

async function fetchTransmissaoDuimp(
  id: number,
  tipo: string,
  transmitirComErros: boolean,
  idDespachante: number
): Promise<any> {
  let url: string =
    process.env.REACT_APP_QCX_API_DECLARACAO_IMPORTACAO_ENDPOINT! + `/transmissao-duimp/${id}?TIPO=${tipo}`;

  if (transmitirComErros != null && transmitirComErros != undefined) {
    url += `&transmitir-erros=${transmitirComErros}`;
  }

  let shapeUrl = `/v2/transmissao-duimp/${id}/iniciar`;
  let urlV2 = process.env.REACT_APP_QCX_API_DECLARACAO_IMPORTACAO_ENDPOINT! + shapeUrl;

  if (idDespachante) {
    urlV2 += `?id-despachante=${idDespachante}`;
  }

  try {
    const response = await doGetQCXRequest([urlV2]);
    return response;
  } catch (error: any) {
    return error.response;
  }
}

async function fetchTransmissaoDiagnosticoDuimpById(
  id: number,
  tipo: string,
  transmitirComErros: boolean
): Promise<any> {
  let url: string =
    process.env.REACT_APP_QCX_API_DECLARACAO_IMPORTACAO_ENDPOINT! + `/diagnostico-duimp/${id}?TIPO=${tipo}`;

  if (transmitirComErros != null && transmitirComErros != undefined) {
    url += `&transmitir-erros=${transmitirComErros}`;
  }

  try {
    const response = await doGetQCXRequest([url]);
    return response;
  } catch (error: any) {
    return error.response;
  }
}

async function fetchObterChavesRegistroDuimp(id: number): Promise<any> {
  let url: string = process.env.REACT_APP_QCX_API_DECLARACAO_IMPORTACAO_ENDPOINT! + `/obter-chaves/${id}`;

  try {
    const response = await doGetQCXRequest([url]);
    return response;
  } catch (error: any) {
    return error.response;
  }
}

async function fetchRegistraDuimp(id: number, tipo: string, transmitirComErros: boolean): Promise<any> {
  let url: string =
    process.env.REACT_APP_QCX_API_DECLARACAO_IMPORTACAO_ENDPOINT! + `/solicitar-registro/${id}?TIPO=${tipo}`;

  if (transmitirComErros != null && transmitirComErros != undefined) {
    url += `&transmitir-erros=${transmitirComErros}`;
  }

  try {
    const response = await doGetQCXRequest([url]);
    return response;
  } catch (error: any) {
    return error.response;
  }
}

async function fetchRelatorioTransmissaoDuimp(id: number): Promise<any> {
  const url: string = process.env.REACT_APP_QCX_API_DECLARACAO_IMPORTACAO_ENDPOINT! + `/relatorio-duimp/${id}`;

  try {
    const response = await doGetQCXRequest([url]);
    return response;
  } catch (error: any) {
    return error.response;
  }
}

async function generateReportDiagnosticoDI(id: number): Promise<any> {
  const queryParams = [{ name: 'TIPO', value: 'DIAGNOSTICO' }];

  return doGetQCXRequest(['diduimp', 'xml-report', 'di', id], queryParams);
}

async function generateReportRegistroDI(id: number): Promise<any> {
  const queryParams = [{ name: 'TIPO', value: 'REGISTRO' }];

  return doGetQCXRequest(['diduimp', 'xml-report', 'di', id], queryParams);
}

async function fetchPlanilhaTratamentoTributarioDuimp(id: number) {
  return doGetQCXRequest(['diduimp', 'obtem-planilha-tratamento-tributario', id], [], {
    responseType: 'blob',
  });
}

async function importAtributosFundamentosLegaisDuimp(data: any) {
  return doPostQCXRequest(['diduimp', 'importacao-fundamentos-legais'], data);
}

async function importAtributosDuimp(id: number, data: any) {
  return doPostQCXRequest(['diduimp', 'importar-planilha-atributos-duimp', id], data);
}

async function fetchRetificarDuimp(id: number): Promise<any> {
  let url: string = process.env.REACT_APP_QCX_API_FATURA_ENDPOINT! + `/retificar/diduimp/${id}`;

  try {
    const response = await doPutQCXRequest([url]);
    return response;
  } catch (error: any) {
    return error.response;
  }
}

async function fetchRecuperarStatusDuimp(id: number): Promise<any> {
  let url: string = process.env.REACT_APP_QCX_API_FATURA_ENDPOINT! + `/recuperar-status/diduimp/${id}`;

  try {
    const response = await doPutQCXRequest([url]);
    return response;
  } catch (error: any) {
    return error.response;
  }
}

async function fetchPlanilhaFundamentoLegalDuimp(id: number) {
  return doGetQCXRequest(['diduimp', 'obtem-planilha-fundamento-legal', id], [], {
    responseType: 'blob',
  });
}

async function fetchPlanilhaAtributosDuimp(id: number) {
  return doGetQCXRequest(['diduimp', 'exportar-planilha-atributos-duimp', id], [], {
    responseType: 'blob',
  });
}

async function importAtributosTratamentosTributariosDuimp(data: any) {
  return doPostQCXRequest(['diduimp', 'importacao-tratamento-tributarios'], data);
}

export {
  fetchCriaDiagnostico,
  fetchDataDiagnostico,
  generateReportDiagnosticoDI,
  generateReportRegistroDI,
  fetchTransmissaoDuimp,
  fetchRelatorioTransmissaoDuimp,
  fetchRegistraDuimp,
  fetchTransmissaoDiagnosticoDuimpById,
  fetchPlanilhaTratamentoTributarioDuimp,
  fetchPlanilhaFundamentoLegalDuimp,
  importAtributosTratamentosTributariosDuimp,
  importAtributosFundamentosLegaisDuimp,
importAtributosDuimp,
  fetchObterChavesRegistroDuimp,
  fetchRetificarDuimp,
  fetchApagarTransmissaoDuimp,
  fetchRecuperarStatusDuimp,
  fetchPlanilhaAtributosDuimp,
};
